import React from 'react'
import { StepperContextProvider } from '../SurveyFeature/components/SurveyFeatureStepper/useStepper'
import { RenderSections } from '../SurveyFeature/components/RenderSections'

interface SectionBySectionViewProps {
  surveySections: any[]
  onSubmit: () => Promise<void>
}

const SectionBySectionView: React.FC<SectionBySectionViewProps> = ({ surveySections, onSubmit }) => {
  return (
        <StepperContextProvider>
            <RenderSections rawSections={surveySections} onSubmit={onSubmit} />
        </StepperContextProvider>
  )
}

export default SectionBySectionView
